var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DBE7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2273 7H9.31818C8.59318 7 8 7.59318 8 8.31818V17.5455H9.31818V8.31818H17.2273V7ZM19.2045 9.63636H11.9545C11.2295 9.63636 10.6364 10.2295 10.6364 10.9545V20.1818C10.6364 20.9068 11.2295 21.5 11.9545 21.5H19.2045C19.9295 21.5 20.5227 20.9068 20.5227 20.1818V10.9545C20.5227 10.2295 19.9295 9.63636 19.2045 9.63636ZM19.2045 20.1818H11.9545V10.9545H19.2045V20.1818Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHover);
export default __webpack_public_path__ + "static/media/copy-hover.d483eeda3b12121b670888de66c72d6b.svg";
export { ForwardRef as ReactComponent };